export enum MagicFileType {
  SIGNATURE_DOCUMENT = "SIGNATURE_DOCUMENT",
  IDENTIFICATION_DOCUMENT = "IDENTIFICATION_DOCUMENT",
  INVOICE = "INVOICE",
}
